import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconQuoteComponent } from "./med-icon-quote.component";

@NgModule({
  declarations: [
    MedIconQuoteComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconQuoteComponent,
  ],
})
export class MedIconQuoteModule { }
